import clsx from "clsx";

// LQC-2941 - a free-text field (External ID). Writes on every keystroke: nothing is
// derived from it, so there is no half-typed state to guard.
interface ITicketTextInput {
  value: string;
  onChange: (value: string) => void;
  testId: string;
  placeholder?: string;
  isDisabled?: boolean;
}

const TicketTextInput = ({
  value,
  onChange,
  testId,
  placeholder = "",
  isDisabled = false,
}: ITicketTextInput) => (
  <input
    data-testid={testId}
    id={testId}
    type="text"
    value={value}
    placeholder={placeholder}
    disabled={isDisabled}
    onChange={(e) => onChange(e.target.value)}
    className={clsx(
      "h-[28px] w-full rounded-md border border-gray-300 bg-transparent px-2 text-xs outline-none dark:border-gray-600 dark:bg-gray-800 dark:text-gray-200",
      isDisabled && "cursor-not-allowed opacity-50",
    )}
  />
);

export default TicketTextInput;
